import PropTypes from "prop-types";
import React, { Component } from "react";
import { Container, Menu, Responsive, Segment, Visibility } from "semantic-ui-react";
import LogoutButton from "../../../LogoutButton";
import LoginButton from "../../../LoginButton";
import HomepageHeading from "../Heading";
import NavLink from "../../../NavLink";
import ProfileLink from "../ProfileLink";
import ClockLink from "../../../../scenes/Clock/Links";
import ToolLink from "../../../../scenes/Tools/Links";
import InventoryLink from "../../../../scenes/Inventory/Links";
import LanguageToggle from "../LanguageToggle";

import AdminLink from "../AdminLink";

class DesktopContainer extends Component {


    state = {};

    hideFixedMenu = () => this.setState({ fixed: false });
    showFixedMenu = () => this.setState({ fixed: true });

    render() {
        const { children, heading } = this.props;
        const { fixed } = this.state;


        return (
            <Responsive {...Responsive.onlyComputer} minWidth={768}>
                <Visibility once={false} onBottomPassed={this.showFixedMenu} onBottomPassedReverse={this.hideFixedMenu}>
                    <Segment inverted textAlign='center' style={{
                        minHeight: heading ? 700 : 0,
                        padding: '1em 0em',
                        background: !heading ? 'rgba(0, 0, 0, 0.4)' : 'linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4) ),url("https://www.tn-spezialitaeten.ch/wp-content/uploads/2017/10/hintergrund_bright.png")',
                        backgroundSize: 'cover',
                        backgroundPosition: '50% 25%'
                    }} vertical>
                        <Menu
                            fixed={fixed ? 'top' : null}
                            inverted={!fixed}
                            pointing={!fixed}
                            secondary={!fixed}
                            size='large'
                            style={{border: 'none'}}
                        >
                            <Container>
                                <Menu.Item>
                                    <img alt={'Weinkulturen'} style={{width: '8em', margin: '-.3em 0'}}
                                         src='https://weinkulturen.ch/wp-content/uploads/2017/12/cropped-weinkulturen-2.png'/>
                                </Menu.Item>
                                <NavLink to={'/'}>Home</NavLink>
                                <AdminLink/>
                                <ProfileLink/>
                                <ClockLink/>
                                <ToolLink/>
                                <InventoryLink/>
                                <LanguageToggle/>
                                <LoginButton fixed={fixed} />
                                <LogoutButton fixed={fixed} />
                            </Container>
                        </Menu>
                        {heading ? <HomepageHeading /> : ''}
                    </Segment>
                </Visibility>
                {children}
            </Responsive>
        )
    }
}

DesktopContainer.propTypes = {
    children: PropTypes.node,
};

export default DesktopContainer;



// WEBPACK FOOTER //
// ./src/components/Homepage/components/DesktopContainer/index.js